//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ImagePreview",
  props: {
    previewList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    getPreviewImgList(data) {
      return data.map((image) => image.pictureUrl);
    },
    /**
     * @descripttion: 预览图片
     * @Author: juanjuanhui
     * @Date: 2021-12-16 18:55:09
     */
    handlePreviewImg(data) {
      this.$emit("handlePreviewImg", data);
    },
  },
};
